export default {
  'inviteRebate.tabDeposit': 'Hoàn tiền nạp',
  'inviteRebate.tabBet': 'Hoàn tiền cược',
  'inviteRebate.tabWinLoss': 'Hoàn tiền thắng/thua',

  'inviteRebate.colSettleDate': 'Ngày thanh toán',
  'inviteRebate.colSettleMonth': 'Tháng thanh toán',
  'inviteRebate.colInviter': 'Người mời',
  'inviteRebate.colCoin': 'Loại tiền',
  'inviteRebate.colHitTier': 'Bậc đạt được',
  'inviteRebate.tierN': 'Bậc {n}',
  'inviteRebate.level1': 'Cấp 1',
  'inviteRebate.level2': 'Cấp 2',
  'inviteRebate.level3': 'Cấp 3',
  'inviteRebate.levelN': 'Cấp {n}',
  'inviteRebate.colDepositBase': 'Cơ số nạp',
  'inviteRebate.colBetBase': 'Cơ số cược hợp lệ',
  'inviteRebate.colWinLossBase': 'Cơ số thắng/thua thuần',
  'inviteRebate.colCashAmount': 'Số tiền hoàn',
  'inviteRebate.colCashAmountTotal': 'Tổng',
  'inviteRebate.colCumulativeCash': 'Hoàn tiền lũy kế',
  'inviteRebate.colExtraAward': 'Thưởng thêm',
  'inviteRebate.colAwardStatus': 'Trạng thái',
  'inviteRebate.awardStatus1': 'Chờ phát',
  'inviteRebate.awardStatus2': 'Đã phát',
  'inviteRebate.awardStatus3': 'Đã từ chối',
  'inviteRebate.colUpdateTime': 'Thời gian cập nhật',
  'inviteRebate.colOperation': 'Thao tác',
  'inviteRebate.colGameType': 'Loại sảnh',
  'inviteRebate.calcDetail': 'Chi tiết tính toán',
  'inviteRebate.calcDetailTitle': 'Chi tiết tính hoàn tiền',
  'inviteRebate.all': 'Tất cả',
  'inviteRebate.search': 'Tìm kiếm',
  'inviteRebate.reset': 'Đặt lại',
  'inviteRebate.export': 'Xuất',
  'inviteRebate.exportEmpty': 'Không có dữ liệu để xuất',
  'inviteRebate.operationFail': 'Thao tác thất bại',

  'inviteRebate.colFriendAccount': 'Tài khoản bạn',
  'inviteRebate.colLevel': 'Cấp',
  'inviteRebate.colBaseAmount': 'Cơ số',
  'inviteRebate.colRatio': 'Tỷ lệ',
  'inviteRebate.colContributedAmount': 'Số tiền góp',
  'inviteRebate.colFriendDetail': 'Chi tiết bạn',
  'inviteRebate.ngrFriendDetailHint': 'Chỉ hiển thị bạn có hoạt động trong kỳ (GGR / khuyến mãi / đổi điểm ≠ 0); mỗi dòng làm tròn riêng nên tổng có thể lệch 0.01 so với hoa hồng kỳ',
  'inviteRebate.colRemark': 'Ghi chú',
  'inviteRebate.remarkPlaceholder': 'Ghi chú khi xác nhận/từ chối phát (tối đa 200 ký tự)',
  'inviteRebate.extraAward': 'Thưởng thêm',
  'inviteRebate.extraPoint': 'Điểm {n}',

  'inviteRebate.actionConfirmIssue': 'Xác nhận phát',
  'inviteRebate.actionReject': 'Từ chối',
  'inviteRebate.confirmIssueTip': 'Xác nhận phát khoản hoàn tiền này? Tiền sẽ được ghi có ngay.',
  'inviteRebate.confirmIssueSuccess': 'Phát thành công',
  'inviteRebate.rejectIssueTip': 'Từ chối khoản hoàn tiền này? Sẽ không được phát nữa.',
  'inviteRebate.rejectIssueSuccess': 'Đã từ chối',
  'inviteRebate.tabNgr': 'Hoàn tiền NGR',
  'inviteRebate.colSettlePeriod': 'Kỳ kết toán',
  'inviteRebate.settlePeriodTip': 'Lọc theo ngày bắt đầu kỳ (ngày 1 / 16 hàng tháng)',
  'inviteRebate.colNgrBase': 'Cơ sở NGR',
  'inviteRebate.colPeriodCommission': 'Hoa hồng kỳ này',
  'inviteRebate.colCarryIn': 'Kết chuyển kỳ trước',
  'inviteRebate.carryInFrom': 'từ {{period}}',
  'inviteRebate.colPayable': 'Số phải trả',
  'inviteRebate.awardStatus4': 'Không phải trả · Kết chuyển',
  'inviteRebate.noPayableNote': 'Phải trả ≤ 0, không phát; số âm kết chuyển kỳ sau',
  'inviteRebate.colFriendGgr': 'GGR bản thân',
  'inviteRebate.colFriendBonus': 'Ưu đãi đã nhận',
  'inviteRebate.colFriendPointExchange': 'Đổi điểm',
};
